import logo from "../images/CSI-Logo.png"
import "./Footer.css"

const Footer = () => {
  return (
    <div className="footer">
      <div className="logo">
        <img src={logo} alt="Logo" />
        <div className="logoTxt">CSI</div>
      </div>
      <div className="copyrightTxt">
        <div>&copy; 2022 CSI</div>
        <div id="comma">,&nbsp;</div>
        <div>All Rights Reserved.</div>
      </div>
    </div>
  )
}

export default Footer
